export default __webpack_public_path__ + "static/media/submit.0994e774.svg";